import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { Router } from '@angular/router';
// import SecureLS from 'secure-ls';
// var ls = new SecureLS({ encodingType: 'base64' });
import ls from 'localstorage-slim';

@Injectable({
    providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
    /**
     * Constructor
     */
    constructor(private _authService: AuthService, private _router: Router) { }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let access_token = ls.get('accessToken');
        if (access_token && access_token == 'undefined') {
            access_token = '';
        }
        // Clone the request object
        req = req.clone({ withCredentials: true });
        // Request
        //
        // If the access token didn't expire, add the Authorization header.
        // We won't add the Authorization header if the access token expired.
        // This will force the server to return a "401 Unauthorized" response
        // for the protected API routes which our response interceptor will
        // catch and delete the access token from the local storage while logging
        // the user out from the app.
        if (access_token) {
            req = req.clone({ headers: req.headers.set('x-access-token', `${access_token}`) });
            req = req.clone({ headers: req.headers.set('Cache-Control', 'no-cache') });
            req = req.clone({ headers: req.headers.set('Pragma', 'no-cache') });
        }

        // Response
        return next.handle(req).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if (event.headers.get('x-access-token')) {
                        access_token = event.headers.get('x-access-token');
                        ls.set('accessToken', access_token);
                    }
                    if (event.status == 200) {
                        if (event.body.status == 404) {
                            this._authService.openSnackBar(event.body.message, 'mat-error');
                        }
                    }
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
              
                let err: any = ''

                if (error['status'] == 500 || error['code'] == 500 || error['status'] == 406 || error['status'] == 403 ) {
                    err = error.error.message;
                    if (err) {
                        if (error.status == 403) { // Catch "403 Session expired" responses
                           
                            this._authService.onAuthError("Session expired,please sign in again");
                            this.clearStorage();
                            return;
                        } else if (error.status === 406) { // Catch "406 Unauthorized" responses
                            // Sign out
                            if (access_token) {
                                this.clearStorage();
                                this._router.navigate(['/sign-out']);
                                this._authService.signOut().subscribe((res: any) => {
                                   
                                    return;
                                });
                            } else {
                                this._authService.onAuthError("Session expired,please sign in again");
                                this.clearStorage();
                                return;
                            }
                        }
                    }
                }
                return throwError(error);
            })
        );
    }

    private clearStorage() {
        localStorage.clear();
        indexedDB.deleteDatabase('services');
        this._router.navigate(['/sign-out']);
    }

}
